import {IRole} from "../app/modules/auth/models/interfaces";

export const ROLE_PATIENT: IRole = {name: 'ROLE.PATIENT', value: 'ROLE_PATIENT'};
export const ROLE_PROFESSIONAL: IRole = {name: 'ROLE.PROFESSIONAL', value: 'ROLE_PROFESSIONAL'};
export const ROLE_ADMIN_CENTER: IRole = {name: 'ROLE.ADMIN_CENTER', value: 'ROLE_ADMIN_CENTER'};
export const ROLE_SUPER_ADMIN: IRole = {name: 'ROLE.ADMIN', value: 'ROLE_ADMIN'};


export const AVAILABLE_ROLES: IRole[] = [
  ROLE_PATIENT,
  ROLE_PROFESSIONAL,
  ROLE_ADMIN_CENTER,
  ROLE_SUPER_ADMIN,
]

/**
 * Returns an array of all roles by the specified key.
 * @param {string} key - The key to use for retrieving roles. Can be either 'value' or 'name'.
 * @returns {Array} An array of all roles by the specified key.
 *
 * @author Carlos Duardo <carlos.duardo@qualud.com>
 */
export function GET_ALL_ROLES_BY_KEY(key: 'value' | 'name' = 'value') {
  return AVAILABLE_ROLES.map(role => role[key]);
}
